(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Section JS is concatenated into a single bundle, so everything here is
  // scoped to avoid clashing with other sections' top-level declarations.
  (function () {
  const SECTION_ID = 'cart-drawer';

  const drawer = () => document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    const el = drawer();
    if (!el) return;
    if (!el.open) el.showModal();
  }

  function closeDrawer() {
    const el = drawer();
    if (el?.open) el.close();
  }

  // Swap in freshly rendered markup returned by the Section Rendering API.
  // Only the panel's contents are replaced so the <dialog> stays open.
  function renderSection(html) {
    const el = drawer();
    if (!el || !html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextPanel = parsed.querySelector('[data-cart-drawer-panel]');
    const currentPanel = el.querySelector('[data-cart-drawer-panel]');
    if (!nextPanel || !currentPanel) return;

    currentPanel.innerHTML = nextPanel.innerHTML;
    currentPanel.dataset.cartCountSource = nextPanel.dataset.cartCountSource;

    const count = Number(nextPanel.dataset.cartCountSource || 0);
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = count;
      node.classList.toggle('header__cart-count--empty', count === 0);
    });
  }

  function announce(message) {
    const region = drawer()?.querySelector('[data-cart-live-region]');
    if (region) region.textContent = message;
  }

  async function cartRequest(url, body) {
    const el = drawer();
    el?.setAttribute('data-loading', '');

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: SECTION_ID, sections_url: window.location.pathname }),
      });

      const data = await response.json();

      if (!response.ok) {
        announce(data.description || data.message || '');
        return { ok: false, data };
      }

      renderSection(data.sections?.[SECTION_ID]);
      return { ok: true, data };
    } catch (error) {
      console.error('Cart request failed', error);
      return { ok: false };
    } finally {
      drawer()?.removeAttribute('data-loading');
    }
  }

  async function changeLine(line, quantity) {
    const el = drawer();
    await cartRequest(el.dataset.cartChangeUrl, { line: Number(line), quantity: Number(quantity) });
  }

  async function addToCart(form) {
    const el = drawer();
    const formData = new FormData(form);
    const items = [
      {
        id: Number(formData.get('id')),
        quantity: Number(formData.get('quantity') || 1),
      },
    ];

    const sellingPlan = formData.get('selling_plan');
    if (sellingPlan) items[0].selling_plan = Number(sellingPlan);

    const properties = {};
    formData.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) items[0].properties = properties;

    const submit = form.querySelector('[type="submit"]');
    submit?.setAttribute('aria-disabled', 'true');

    const result = await cartRequest(el.dataset.cartAddUrl, { items });

    submit?.removeAttribute('aria-disabled');

    if (result.ok) {
      openDrawer();
    } else if (result.data) {
      const error = form.querySelector('[data-product-form-error]');
      if (error) error.textContent = result.data.description || result.data.message || '';
    }
  }

  // Delegated listeners so they survive the panel being re-rendered.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-drawer-open]');
    if (opener && drawer()) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }

    const quantityButton = event.target.closest('[data-cart-quantity]');
    if (quantityButton) {
      changeLine(quantityButton.dataset.cartLine, quantityButton.dataset.cartQuantity);
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (input) changeLine(input.dataset.cartLine, input.value);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !drawer()) return;

    event.preventDefault();
    addToCart(form);
  });

  // Clicking the dialog backdrop closes the drawer. A click inside the panel
  // reports the panel as the target, so only bare dialog hits count.
  document.addEventListener('click', (event) => {
    const el = drawer();
    if (el?.open && event.target === el) closeDrawer();
  });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Section JS is concatenated into a single bundle, so everything here is
  // scoped to avoid clashing with other sections' top-level declarations.
  (function () {
  // Close any open header dropdown when a click lands outside it, and close
  // dropdowns plus the mobile menu on Escape.
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-dropdown][open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });

    // The backdrop is a pseudo-element on the <details>, so a click on it
    // reports the <details> itself as the target rather than the panel.
    const openMenu = document.querySelector('.header__menu-toggle[open]');
    if (openMenu && event.target === openMenu) openMenu.open = false;
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-dropdown][open]').forEach((dropdown) => {
      dropdown.open = false;
      dropdown.querySelector('summary')?.focus();
    });

    const mobileMenu = document.querySelector('.header__menu-toggle[open]');
    if (mobileMenu) {
      mobileMenu.open = false;
      mobileMenu.querySelector('summary')?.focus();
    }
  });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Section JS is concatenated into one bundle, so scope everything.
  (function () {
    const root = () => document.querySelector('.product');

    function getVariants() {
      const node = document.querySelector('[data-product-variants]');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        console.error('Could not parse variant data', error);
        return [];
      }
    }

    function selectedOptions() {
      return Array.from(document.querySelectorAll('[data-product-option-input]:checked')).map(
        (input) => input.value
      );
    }

    function findVariant(variants, options) {
      return variants.find(
        (variant) =>
          variant.options.length === options.length &&
          variant.options.every((value, index) => value === options[index])
      );
    }

    function updateGallery(mediaId) {
      if (!mediaId) return;
      const target = document.querySelector(`[data-media-id="${mediaId}"]`);
      target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    function updateVariant() {
      const container = root();
      if (!container) return;

      const variants = getVariants();
      const options = selectedOptions();
      const variant = findVariant(variants, options);

      // Reflect the chosen value next to each option name.
      options.forEach((value, index) => {
        const label = container.querySelector(`[data-product-option-selected="${index}"]`);
        if (label) label.textContent = value;
      });

      const idInput = container.querySelector('[data-product-variant-id]');
      const submit = container.querySelector('[data-product-submit]');
      const priceEl = container.querySelector('[data-product-price]');
      const availabilityEl = container.querySelector('[data-product-availability]');
      const skuEl = container.querySelector('[data-product-sku]');

      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.dataset.unavailableText || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? submit.dataset.addText || submit.textContent
          : submit.dataset.soldOutText || submit.textContent;
      }

      if (priceEl) {
        const compare = variant.on_sale
          ? `<s class="price__compare">${variant.compare_at_price}</s>`
          : '';
        priceEl.innerHTML = `<div class="price${variant.on_sale ? ' price--on-sale' : ''}">
          <span class="price__current">${variant.price}</span>${compare}
        </div>`;
      }

      if (availabilityEl) {
        availabilityEl.classList.toggle('product__availability--sold-out', !variant.available);
        availabilityEl.textContent = variant.available
          ? availabilityEl.dataset.inStockText || availabilityEl.textContent
          : availabilityEl.dataset.soldOutText || availabilityEl.textContent;
      }

      if (skuEl) skuEl.textContent = variant.sku || '';

      updateGallery(variant.media_id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    document.addEventListener('change', (event) => {
      if (event.target.closest('[data-product-option-input]')) updateVariant();
    });

    // Quantity stepper on the product form.
    document.addEventListener('click', (event) => {
      const step = event.target.closest('[data-quantity-step]');
      if (!step) return;

      const input = step.parentElement.querySelector('[data-quantity-input]');
      if (!input) return;

      const next = Number(input.value || 1) + Number(step.dataset.quantityStep);
      input.value = Math.max(Number(input.min || 1), next);
    });

    // Thumbnails scroll the gallery rather than jumping the whole page.
    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-product-thumb]');
      if (!thumb) return;

      event.preventDefault();
      updateGallery(thumb.dataset.productThumb);

      document
        .querySelectorAll('[data-product-thumb]')
        .forEach((node) => node.setAttribute('aria-current', String(node === thumb)));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
